import template from './enter-data-form.html';
import controller from './enter-data-form-controller';

const EnterDataFormComponent = {
    bindings: {
        changeReasonList: '<',
        facilityFields: '<',
        facilitySettings: '<',
        formMetadata: '<',
        isEditMode: '<',
        isFormSaved: '<',
        isFormCommitted: '<',
        lastUpdatedByEmail: '<',
        merColumns: '<',
        relatedModels: '<',
        savedFormData: '<',
        showSavedWarning: '<',
        statToLabelDict: '<'
    },
    controller,
    template
};

export default EnterDataFormComponent;



// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-form/enter-data-form-component.js